module.exports = __webpack_public_path__ + "static/media/fe_drop-down-blue.2fdf4d05.svg";